import React, { useState, useRef } from "react";
import axios from "axios";


const useItem = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, values }) => { },
}) => {
    const mainApi = '/koha/item'
    const [data, setData] = useState([])
    const [specific_data, set_specific_data] = useState([])
    const [item_biblionnumber_data, set_item_biblionnumber_data] = useState([])
    const [extendResponseData, setExtendResponseData] = useState([])
    const abortControllerRef = useRef(null); // 新增一個 ref 存 controller

    const getItemData = (params, options = { useCancelToken: false }) => {
        // 取消前一次請求
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;

        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
            signal: controller.signal,
        })
            .then((response) => {
                let data = response.data
                
                // 過濾掉 item_barcode 為 null 的數據
                // const filteredData = (data?.data || []).filter(item => item.item_barcode !== null);

                // 更新狀態，使用過濾後的數據
                setData(data?.data || []);
                onFinish({
                    axiosMode: "get",
                    status: data ? "success" : "error",
                    // values: { ...data, data: filteredData },
                });

                return {
                    ...data
                }
            })
            .catch((error) => {
                if (axios.isCancel(error) || error.name === 'CanceledError') {
                    console.log("Request canceled", error.message);
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error"
                    });
                }
            });
    }
    const getItem_ApiData = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(`${mainApi}/api`, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })

                return {
                    ...data
                }
            });
    }
    const postItemData = (data) => {
        onBefore({ axiosMode: "post", values: data })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                onFinish({ axiosMode: "post", status: status === "success" ? "success" : "error", responseData })
            })
            .catch((ex) => {
                onFinish({ axiosMode: "post", status: "error", ex })
            })
    }
    const patchItemData = (data) => {
        onBefore({ axiosMode: "patch", values: data })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                const result = response.data
                const bSuccess = result?.status === "success";
                onFinish({ axiosMode: "patch", status: bSuccess ? "success" : "error", values: bSuccess ? result.data : result.message })
            })
            .catch((ex) => {
                onFinish({ axiosMode: "patch", status: "error", ex })
            })
    }
    const deleteItemData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    //key 的轉換，兩隻api 的內容長不一樣 viewkey:postpatchkey
    const transformData = (inputData) => {
        const keyMapping = {
            "bib_biblionumber": "biblio_id",
            "item_itemnumber": "item_id",
            "bib_author": "author",
            "bib_title": "title",
            "bib_subtitle": "subtitle",
            "bib_notes": "notes",
            "bib_copyrightdate": "copyright_date",
            "bib_datecreated": "date_created",
            "bib_seriestitle": "series_title",
            "bib_publisher": "publisher",
            "bibitem_biblioitemnumber": "biblio_id",
            "bibitem_volume": "volume",
            "bibitem_itemtype": "item_type_id",
            "bibitem_itemtype_description": "item_type_description",
            "bibitem_isbn": "isbn",
            "bibitem_publishercode": "publisher_code",
            "bibitem_editionstatement": "edition_statement",
            "bibitem_illus": "illustrations",
            "bibitem_pages": "pages",
            "bibitem_size": "size",
            "bibitem_place": "place",
            "bib_cover_images": "cover_images",
            "item_itype": "item_type_id",
            "item_itype_description": "item_type_description",
            "item_branchcode_holding": "holding_library_id",
            "item_branchname_holding": "holding_library_name",
            "item_branchcode_home": "home_library_id",
            "item_branchname_home": "home_library_name",
            "item_itemcallnumber": "callnumber",
            "item_lastseen": "last_seen_date",
            "item_dateaccessioned": "acquisition_date",
            "item_datelastborrowed": "last_borrowed_date",
            "item_barcode": "external_id",
            "item_call_number_source_code": "call_number_source",
            "item_call_number_source_name": "call_number_source_name",
            "item_bookable": "bookable",
            "item_notforloan": "not_for_loan_status",
            "item_damaged": "damaged_status",
            "item_itemlost": "item_lost",
            "item_onloan": "on_loan_date",
            "item_issue_count": "issue_count",
            "item_renewal_count": "renewal_count",
            "item_location": "location",
            "item_withdrawn": 'withdrawn',
            "item_materials_notes": 'materials_notes',
            "item_restricted_status": 'restricted_status',
            "item_copynumber": "copy_number",
            "item_coded_location_qualifier": "coded_location_qualifier",
            "item_purchase_price": "purchase_price",
            "item_serial_issue_number": "serial_issue_number",
            "item_inventory_number": "inventory_number",
            "item_shelving_control_number": "shelving_control_number",
            "item_collection_code": "collection_code",
            "item_replacement_price_date": "replacement_price_date",
            "item_acquisition_source": "acquisition_source",
            "issue_id": "issue_id",
            "issue_issuedate": "issue_date",
            "issue_date_due": "date_due",
            "issue_days_due": "days_due",
            "issue_days_over": "days_over",
            "issue_borrowernumber": "borrower_number",
            "issue_borrower_cardnumber": "borrower_card_number",
            "issue_branchcode": "branch_id",
            "issue_branchname": "branch_name",
            "issue_selfcheckout": "self_checkout",
            "issue_cancheckout": "can_checkout",
            "reserve_selfhold": "self_hold",
            "reserve_canhold": "can_hold",
            "items_count": "items_count",
            "item_internal_notes": "internal_notes",
            "item_public_notes": "public_notes",
        };
        let transformedData = {};
        for (let key in inputData) {
            const newKey = keyMapping[key] || key;
            transformedData[newKey] = inputData[key];
        }
        return transformedData;
    }
    const exportData = (data) => {
        onBefore({
            axiosMode: "export"
        })
        axios.get(`${mainApi}_export/excel`,
            {
                responseType: 'blob',
                params: data,
            },
        )
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯出清單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "export",
                        status: "success"
                    }
                )
            })
    }
    const importData = (data) => {
        onBefore({
            axiosMode: "import"
        })
        const files = data.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', data?.choose_column);
        form_data.append('default_column', JSON.stringify(data?.columns));
        form_data.append('biblionumber', data?.biblionumber);
        form_data.append('biblio_id', data?.biblio_id);
        axios
            .post(`${mainApi}_import/read_sample`, form_data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                setExtendResponseData(responseData.data)

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    const downloadData = () => {
        onBefore({
            axiosMode: "download_sample"
        })
        axios
            .get(`${mainApi}_import/manual`, {
                responseType: 'blob',
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯入範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "download_sample",
                        status: "success"
                    }
                )
            })
    }
    const overData = (data) => {
        onBefore({
            axiosMode: "over"
        })
        axios
            .post(`${mainApi}_import/over_data`, data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    return {
        ItemData: data,
        getItemData,
        getItem_ApiData,
        postItemData,
        patchItemData,
        deleteItemData,
        transformData,
        exportData,
        importData,
        downloadData,
        overData,
    }
}
export { useItem }
